/**
 * What a list shows where its photograph would be, when it has none: porcelain with the crest in
 * Bulhões Green, the board's asset of 2026-09-29 (`docs/internal/list_card_placeholder.svg`,
 * 595 × 744, the card's own 4:5). It replaced the oxide frame with a porcelain crest.
 *
 * One file for every place a list wears it — the search card and the list's hero — so the two
 * can never draw it differently. Product frames are a different placeholder and stay as they are.
 */
export const LIST_COVER_PLACEHOLDER_SRC = "/images/brand/list-card-placeholder.svg";
